import { render, staticRenderFns } from "./_base-scrollable-dropdown.vue?vue&type=template&id=5b8335cc&scoped=true&"
import script from "./_base-scrollable-dropdown.vue?vue&type=script&lang=js&"
export * from "./_base-scrollable-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./_base-scrollable-dropdown.vue?vue&type=style&index=0&id=5b8335cc&prod&lang=less&scoped=true&"
import style1 from "./_base-scrollable-dropdown.vue?vue&type=style&index=1&id=5b8335cc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8335cc",
  null
  
)

export default component.exports